/**
 * Log the error response in the standard format to SumoLogic
 * @param {Object} report The object contains information to be reported, could be a Error object
 * @param {String} logger which action logged this error
 * @param {String} verticalName The vertical state key
 * @param {Number} accountId The account id number from the journey service
 * @param {Number} journeyId The journey id number from the journey service
 * @param {String} level of the console, [INFO, DEBUG, WARN, ERROR]
 * @returns {Object} A constructed error payload

 */
export const createReporterPayload = (report, logger, verticalName, accountId, journeyId, level) => {
    const payload = {
        message: report && (report instanceof Error || typeof report === 'string' ? report.toString() : report.message),
        timeSpent: report.timeSpent || null,
        accountId,
        journeyId,
        level: level || 'ERROR',
        logger,
        verticalName
    };
    const requestData = _getRequestData(report);
    if (requestData) {
        payload.requestData = requestData;
    }
    if (report && report.stack) {
        payload.trace = report.stack;
    }
    // log error to console if it is dev
    if (process.env.NODE_ENV === 'development') {
        switch (payload.level) {
            case 'ERROR':
            case 'WARN': {
                // eslint-disable-next-line no-console
                console.warn(payload);
                break;
            }
            default: {
                // eslint-disable-next-line no-console
                console.info(payload);
            }
        }
    }
    return payload;
};

/**
 * Just trying to optimise the data we need to send...
 * @param {Object} report The object contains information to be reported, could be a Error object
 * @returns {Object} An object containing a cut down version of the request headers.
 */
const _getRequestData = (report) => {
    if (!report) {
        return { error: 'No data supplied' };
    }

    // Currently it only handles error request, may need to add more if we want to log a non error request
    if (!(report instanceof Error) || !report.response) {
        return null;
    }
    const errorData = { ...report };
    errorData.message = report.toString();
    // don't need all the redundant properties
    errorData.config = {
        method: errorData.config.method,
        url: errorData.config.url
    };
    delete errorData.response.headers;
    delete errorData.response.config;
    return errorData;
};
